import * as React from 'react'
import { useMemo } from 'react'
import { useKpiByMonth } from './hooks'
import { Card, Statistic, Flex, Spin, Tooltip } from 'antd'
import { DollarOutlined } from '@ant-design/icons'
import { Column } from '@ant-design/plots'
import { path } from '../../../../libs'

export const KpiWidget = () => {
  const { kpiByMonth, loading } = useKpiByMonth()

  const lastBalance = useMemo(() => {
    if (!kpiByMonth.length) return 0
    const sorted = [...kpiByMonth].sort(
      (a, b) =>
        new Date(a.transactionToMonth).getTime() -
        new Date(b.transactionToMonth).getTime(),
    )
    return parseFloat(sorted[sorted.length - 1].balance)
  }, [kpiByMonth])

  const chartData = useMemo(() => {
    if (!Array.isArray(kpiByMonth)) return []
    return [...kpiByMonth]
      .sort(
        (a, b) =>
          new Date(a.transactionToMonth).getTime() -
          new Date(b.transactionToMonth).getTime(),
      )
      .map((d) => ({
        date: d.transactionToMonth.split(' ')[0],
        balance: parseFloat(d.balance),
      }))
  }, [kpiByMonth])

  return (
    <Card size="small" style={{ flex: 1, minWidth: 320 }}>
      <Spin spinning={loading}>
        <Statistic
          title={
            <Flex align="center" gap={6}>
              <DollarOutlined style={{ color: '#10b981' }} />
              <Tooltip title="Чистый доход по месяцам (депозиты минус доля партнёров). Источник: отчёт KPI.">
                <a target="_blank" href={path.kpi.entry()} style={{ fontSize: 12, color: 'inherit' }}>
                  Income (net balance)
                </a>
              </Tooltip>
            </Flex>
          }
          value={lastBalance.toLocaleString('ru-RU', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
          prefix="$"
          valueStyle={{
            fontSize: 28,
            fontFamily: 'monospace',
            fontWeight: 600,
            color: lastBalance >= 0 ? '#10b981' : '#ef4444',
          }}
        />
        {chartData.length > 1 && (
          <div style={{ height: 180, marginTop: 12 }}>
            <Column
              data={chartData}
              xField="date"
              yField="balance"
              height={180}
              style={{ fill: '#10b981' }}
              axis={{
                x: {
                  label: {
                    style: { fontSize: 10 },
                    autoRotate: true,
                    formatter: (v: string) => {
                      const d = new Date(v)
                      return d.toLocaleDateString('ru-RU', { month: 'short', year: '2-digit' })
                    },
                  },
                },
                y: {
                  label: {
                    style: { fontSize: 10 },
                    formatter: (v: number) => `$${v.toLocaleString('ru-RU')}`,
                  },
                },
              }}
              legend={false}
              tooltip={(d: { date: string; balance: number }) => ({
                name: 'Balance',
                value: `$${d.balance.toLocaleString('ru-RU', { minimumFractionDigits: 2 })}`,
              })}
            />
          </div>
        )}
      </Spin>
    </Card>
  )
}
